// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // firebaseConfig: {
  //   apiKey: "AIzaSyCQPQx3T5lHRkeqP3_Ou3HiR5oBZy78nlg",
  //   authDomain: "fb-clone-c17ed.firebaseapp.com",
  //   databaseURL: "https://fb-clone-c17ed-default-rtdb.firebaseio.com",
  //   projectId: "fb-clone-c17ed",
  //   storageBucket: "fb-clone-c17ed.appspot.com",
  //   messagingSenderId: "951596034535",
  //   appId: "1:951596034535:web:d2023dbc0fd1e4dc2a7542"
  // }
  firebaseConfig: {
    apiKey: "AIzaSyC4n9h0Uaa8TNxvd39mavU1liRZhw1YjUM",
    authDomain: "fakebook-b0165.firebaseapp.com",
    projectId: "fakebook-b0165",
    storageBucket: "fakebook-b0165.appspot.com",
    messagingSenderId: "106395947696",
    appId: "1:106395947696:web:0cffb75a3a32734007e175"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
